import { render, staticRenderFns } from "./SalaryItem.vue?vue&type=template&id=212da3a0&"
import script from "./SalaryItem.vue?vue&type=script&lang=js&"
export * from "./SalaryItem.vue?vue&type=script&lang=js&"
import style0 from "./SalaryItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SalaryItem.vue"
export default component.exports